import React, { Component, Fragment } from 'react'
import ProgressBar from './ProgressBar'
import AudioInfo from './AudioInfo'
import { connect } from 'react-redux'
import { mapDispatchToProps } from '../../helpers/redux.helper'
import Controls from './Controls'
import './index.sass'

class AudioComponent extends Component {
  state = {
    isOpen: true,
    currentIndex: 0,
  }

  setCurrentIndex = index => {
    const {
      actions: { setPlayingVoiceId },
      audioPlayer: { list },
    } = this.props
    this.setState({ currentIndex: index })
    setPlayingVoiceId(list[index].id)
  }

  

  setPlaying = () => {
    const {
      audioPlayer: { isPlaying },
      actions: { setPlayingStatus },
    } = this.props
    isPlaying ? this.audio.pause() : this.audio.play()
    setPlayingStatus(!isPlaying)
  }

  toggleIsOpen = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }

  setDuration = e => {
    this.setState({ duration: e.target.duration })
  }

  autoplayNextTrack = () => {
    const { currentIndex } = this.state
    const {
      actions: { setPlayingStatus },
      audioPlayer: { list },
    } = this.props
    const lastIndex = list.length - 1
    currentIndex !== lastIndex ? this.setCurrentIndex(currentIndex + 1) : setPlayingStatus(false)
  }

  onTimeUpdateHandler = e => {
    this.setState({ currentTime: e.target.currentTime })
    if (this.audio && this.audio.ended) {
      this.autoplayNextTrack()
    }
  }

  componentDidMount = () => {
    const {
      audioPlayer: { currentVoiceId, list },
    } = this.props
    const index = list.findIndex(item => item.id === currentVoiceId)
    this.setState({ currentIndex: index !== -1 ? index : 0 })
    this.audio.addEventListener('loadedmetadata', this.setDuration)
    this.audio.addEventListener('timeupdate', this.onTimeUpdateHandler)
  }

  componentDidUpdate = prevProps => {
    const {
      audioPlayer: { currentVoiceId },
    } = prevProps
    const {
      audioPlayer: { list },
    } = this.props

    if (
      currentVoiceId !== this.props.audioPlayer.currentVoiceId ||
      list.length !== prevProps.audioPlayer.list.length
    ) {
      const index = list.findIndex(item => item.id === this.props.audioPlayer.currentVoiceId)
      this.setState({ currentIndex: index !== -1 ? index : 0 })
    }
    if (
      prevProps.audioPlayer.isPlaying !== this.props.audioPlayer.isPlaying &&
      !this.props.audioPlayer.isPlaying
    ) {
      this.audio.pause()
    }
    if (
      prevProps.audioPlayer.isPlaying !== this.props.audioPlayer.isPlaying &&
      this.props.audioPlayer.isPlaying
    ) {
      this.audio.play()
    }
  }

  componentWillUnmount = () => {
    this.audio.removeEventListener('loadedmetadata', this.setDuration)
    this.audio.removeEventListener('timeupdate', this.onTimeUpdateHandler)
  }

  onTimeUpdate = time => {
    const { currentTime } = this.state
    if (time && time !== currentTime) {
      this.audio.currentTime = time
    }
  }

  download = () => {
    const {
      audioPlayer: { list, currentVoiceId },
    } = this.props
    const audio = list.find(el => el.id === currentVoiceId)
    fetch(audio.audioUrl).then(response => {
      response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = url
        a.download = audio.author
        a.click()
      })
    })
  }

  renderInfoAndControl = isTop => {
    const { currentIndex, isOpen } = this.state
    const {
      audioPlayer: { list },
      actions: { toggleFavoriteVoice, toggleVisibleAudioPlayer, setPlayingStatus },
    } = this.props
    return (
      <div
        className="audio-info-wrapper"
        style={{ justifyContent: isOpen ? 'flex-end' : 'space-between' }}
      >
        {!isTop ? (
          <>
            {!isOpen && (
              <AudioInfo
                author={list[currentIndex] && list[currentIndex].author}
                language={list[currentIndex] && list[currentIndex].language}
              />
            )}
            <button className="btn icon expand" onClick={this.toggleIsOpen} />
            <button
              className="btn btn-close"
              onClick={() => {
                setPlayingStatus(false)
                toggleVisibleAudioPlayer(false)
              }}
            />
          </>
        ) : (
          <>
            <AudioInfo
              author={list[currentIndex] && list[currentIndex].author}
              language={list[currentIndex] && list[currentIndex].language}
            />
            <button className="btn icon download" onClick={this.download} />

            <button
              className={
                list[currentIndex] && list[currentIndex].isFavorite
                  ? 'btn icon favourite-full'
                  : 'btn icon favourite-empty'
              }
              onClick={() => toggleFavoriteVoice(list[currentIndex].id)}
            />
          </>
        )}
      </div>
    )
  }

  render = () => {
    const { currentTime, duration, isOpen, currentIndex } = this.state

    const {
      audioPlayer: { list, isPlaying },
    } = this.props
    const isReady = !!list[currentIndex]
    return (
      <div className="audio-player-new">
        {isOpen && (
          <Fragment>
            {this.renderInfoAndControl(true)}
            <ProgressBar
              duration={duration}
              currentTime={currentTime}
              onTimeUpdate={this.onTimeUpdate}
              isPlaying={isPlaying}
            />
          </Fragment>
        )}
        {isReady && (
          <div className="audio-inner">
            <audio
              preload="none"
              autoPlay={isPlaying ? true : false}
              src={isReady ? list[currentIndex].audioUrl : ''}
              ref={ref => (this.audio = ref)}
            />
            <Controls
              isPlaying={isPlaying}
              setPlaying={this.setPlaying}
              currentIndex={currentIndex}
              setCurrentIndex={this.setCurrentIndex}
              lastIndex={list.length - 1}
            />
            {this.renderInfoAndControl()}
          </div>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  audioPlayer: state.audioPlayer,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AudioComponent)
